module.exports = __webpack_public_path__ + "img/notifications.cdc61f3d.svg";